import injectGlobals from './inject-globals';
import ejectGlobals from './eject-globals';
import globalActionExtender from './global-action-extender';
import saveGlobals from './save-globals';

export default {
  injectGlobals,
  ejectGlobals,
  globalActionExtender,
  saveGlobals,
};
